export default __webpack_public_path__ + "static/media/af.366db578.svg";